import { DealLink as CDealLink, DataNerdScript, getProductProps, orgProps } from '@uswitch/comms-ui.deal-link'
import type { DealLinkProps } from '@uswitch/comms-ui.deal-link'
import React from 'react'

import { clickOutLink } from '../deal/clickout-url'
import { useEcommerceContext } from '~/contexts/ecommerce-context'
import { usePageContext } from '~/contexts/page-context'
import { Deal } from '~/interfaces/types'

const productProps = (pageId: string, deal: Deal, comparisonId: string, position: number, dealUrl: string) =>
  getProductProps({
    pageId,
    deal,
    comparisonId,
    position,
    dealUrl,
    productListEvent: true
  })

const DealLink = (props: DealLinkProps) => {
  const { pageId } = usePageContext()
  const ecommerceContext = useEcommerceContext()

  const isClickout = clickOutLink({ deal: props.deal })?.type === 'CLICKOUT'
  const { comparisonId } = ecommerceContext?.data || props

  return <CDealLink {...props} pageId={pageId} isClickout={isClickout} comparisonId={comparisonId} />
}

export { DealLink, DealLinkProps, DataNerdScript, orgProps, productProps }
